import _EventBus from './EventBus';

export const EventBus = _EventBus;
export const EventBusSingleton = new _EventBus();
